var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlParkingFilled = function SvgHtlParkingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 15a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7ZM7.978 3.928c-.356 0-.691.025-.987.046-.2.014-.369.026-.491.026a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0V9.06a7.4 7.4 0 0 0 .563.022 4.192 4.192 0 0 0 2.6-.736 2.313 2.313 0 0 0 .835-1.837V6.5a2.42 2.42 0 0 0-.7-1.865 3.267 3.267 0 0 0-2.32-.707Zm-.424 4.155a6.42 6.42 0 0 1-.555-.024V4.976h.063c.276-.02.587-.042.909-.042a2.381 2.381 0 0 1 1.645.44A1.456 1.456 0 0 1 10 6.499a1.342 1.342 0 0 1-.469 1.079 3.277 3.277 0 0 1-1.977.505Z"
  })));
};
export default SvgHtlParkingFilled;